import { Box, Typography } from '@mui/material';
import { FONT_WEIGHT, TEXT_SIZE } from '@/typography/Typography';

const ModalHeading = ({ label }: { label: string }) => {
    return (
        <Typography
            fontWeight={FONT_WEIGHT.BOLD}
            fontSize={TEXT_SIZE.MEDIUM_SMALL}
            m={1}
        >
            {label}
        </Typography>
    );
};

const ModalDescription = ({ label }: { label: JSX.Element | string }) => {
    return (
        <Typography
            fontWeight={FONT_WEIGHT.REGULAR}
            fontSize={TEXT_SIZE.MEDIUM_SMALL}
            color="text.secondary"
        >
            {label}
        </Typography>
    );
};

interface ConnectHeaderProps {
    logo?: JSX.Element | null;
    title: string;
    id?: string | null;
    content?: JSX.Element | string | null;
    description?: JSX.Element | string | null;
    content2?: JSX.Element | string | null;
    content3?: JSX.Element | string | null;
    children?: React.ReactNode;
}

export const ConnectHeader = ({
    logo,
    title,
    id,
    content,
    description,
    content2,
    content3,
    children
}: ConnectHeaderProps) => {
    return (
        <Box textAlign={'center'} marginTop={'12px'}>
            <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                alignSelf={'center'}
            >
                {logo}
            </Box>
            <ModalHeading label={title} />
            <Typography
                color={'#089855'}
                fontWeight={FONT_WEIGHT.SEMI_BOLD}
                m={1}
            >
                {id}
            </Typography>
            {description && <ModalDescription label={description} />}
            {content && <ModalDescription label={content} />}
            {content2 && (
                <Typography
                    fontWeight={FONT_WEIGHT.BOLD}
                    fontSize={TEXT_SIZE.XS}
                    color="#667085"
                    m={1}
                >
                    {content2}
                </Typography>
            )}
            {content3 && (
                <Typography
                    fontWeight={FONT_WEIGHT.BOLD}
                    fontSize={TEXT_SIZE.XS}
                    color="#667085"
                    m={1}
                >
                    {content3}
                </Typography>
            )}
            {children}
        </Box>
    );
};
